import { render, staticRenderFns } from "./ExpertDetail.vue?vue&type=template&id=0a1e91a8&scoped=true&"
import script from "./ExpertDetail.vue?vue&type=script&lang=js&"
export * from "./ExpertDetail.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/expertshow.css?vue&type=style&index=0&id=0a1e91a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1e91a8",
  null
  
)

export default component.exports